module.exports = __webpack_public_path__ + "static/media/MI_State.cf251b8c.png";